import { Button, Descriptions, Divider, Space } from 'antd';
import styled from 'styled-components';
import { BidPackage } from '../../modules/bid-packages';
import { styledDescriptions } from '../styled/mixin';
import Link from 'antd/lib/typography/Link';
// import 'moment/locale/ko';
import moment from 'moment';
import { phoneFormatter } from '../../util/utils';
// import moment from 'moment-timezone';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface BidPackageDetailComponentProps {
  enterpriseId: string;
  projectId: string;
  bidPackage: BidPackage;
  moveToEditPage: (bidPackageId: number) => void;
  downloadAttachFile: (
    enterpriseId: string,
    projectId: string,
    attachFileId: string,
    fileName: string,
  ) => void;
}
function BidPackageDetailComponent({
  enterpriseId,
  projectId,
  bidPackage,
  moveToEditPage,
  downloadAttachFile,
}: BidPackageDetailComponentProps) {
  const attachedFileList = bidPackage.attachedFiles.map((file: any) => (
    <li key={file.id}>
      <Link
        onClick={(e) => {
          e.stopPropagation();
          downloadAttachFile(enterpriseId, projectId, file.id, file.name);
        }}
      >
        {file.name}
      </Link>
    </li>
  ));
  return (
    <StyledDiv>
      <Descriptions
        title={`${bidPackage.isBudgeting ? '견적' : '입찰'} 정보`}
        bordered
        column={2}
        size="small"
        extra={
          <Button onClick={() => moveToEditPage(bidPackage.id)}>수정</Button>
        }
      >
        <Descriptions.Item label="공사명">{bidPackage.name}</Descriptions.Item>
        <Descriptions.Item label="담당자 정보">
          {bidPackage.bidPackageManagers.map((user: any, index: any) => (
            <div key={index}>
              <span>{user.name}</span>
              {user.workPosition && (
                <Space>
                  <Divider type="vertical" />
                  <span>{user.workPosition}</span>
                </Space>
              )}
              {user.workPhone && (
                <Space>
                  <Divider type="vertical" />
                  <span>{phoneFormatter(user.workPhone, 1)}</span>
                </Space>
              )}
              {/* <Space>
                <Divider type="vertical" />
                <span>{user.email}</span>
              </Space> */}
            </div>
          ))}
        </Descriptions.Item>
        <Descriptions.Item label="공사 시작일">
          {bidPackage.startDate}
        </Descriptions.Item>
        <Descriptions.Item label="공사 종료일">
          {bidPackage.endDate}
        </Descriptions.Item>
        <Descriptions.Item label="견적마감일">
          {moment(bidPackage.bidDueDateTime).format('YYYY-MM-DD HH:mm')}
        </Descriptions.Item>
        <Descriptions.Item label="현장설명회 실시여부">
          {bidPackage.isBriefing ? '예' : '아니오'}
        </Descriptions.Item>
        {bidPackage.isBriefing && (
          <Descriptions.Item label="현장설명회 일시">
            {moment(bidPackage.jobWalkDateTime).format('YYYY-MM-DD HH:mm')}
          </Descriptions.Item>
        )}
        {bidPackage.isBriefing && (
          <Descriptions.Item label="현장설명회 장소">
            {bidPackage.briefingSite}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="주의사항" style={{ whiteSpace: 'pre-wrap' }}>
          {bidPackage.instructions}
        </Descriptions.Item>
        <Descriptions.Item label="설계도서">
          {attachedFileList}
        </Descriptions.Item>
      </Descriptions>
    </StyledDiv>
  );
}

export default BidPackageDetailComponent;
